import { createTheme } from "@mui/material/styles";

/* MUI theme kept intentionally light — the TRAPS design system lives in
   src/css/traps.css. This just keeps the few remaining MUI widgets
   (mobile menu, twitter/facebook embeds wrappers) on-brand and prevents
   CssBaseline from painting a white background. */
const theme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#FF5A00" },
    secondary: { main: "#3B7BFF" },
    background: { default: "#0A0E14", paper: "#0F141D" },
    text: { primary: "#E9EDF0", secondary: "rgba(233,237,240,.60)" },
  },
  typography: {
    fontFamily:
      '"Zen Kaku Gothic New","Archivo",system-ui,sans-serif',
  },
});

export default theme;
